import { taskSources, taskAcceptTable } from "../data/TaskAccept";
import MonthSelect from "@/components/MonthSelect.vue";
import SeasonSelect from "@/components/SeasonSelect.vue";

import { post } from "../utils/request";
import { getSeason, getTaskTypeName } from "../utils/utilApi";
import moment from "moment";

export default {
  name: "TaskAccept",
  data() {
    return {
      activeTab: "first",
      // 分页控制
      currentPage: 1,
      pagesize: 10,
      taskSources: [],
      taskAcceptTable: [],
      selectTask: [],
      season: getSeason(),
      month: "",
      year: moment().format("YYYY"),
      taskSource: "全部",
      taskList: [],
      taskListAccept: [
        {
          taskId: 100,
          taskSource: "重大决策部署",
          accomplishDate: "2022-01-31",
          detail: "每少组织开展生活垃圾分类示范片区建设指导工作",
          accept: "已接收",
        },
      ],
      taskListUnAccept: [],
    };
  },
  components: { MonthSelect, SeasonSelect },
  methods: {
    // 切换tab
    handleClick(tab, event) {
    },
    // 选中表中行
    handleSelectionChange(val) {
      this.selectTask = val;
    },

    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    formatter(row, column) {
      if (column.property == "taskType") {
        return getTaskTypeName(row.taskType);
      } else {
        return row[column.property];
      }
    },
    /**
     * @function POST /task/accept
     * @description 接受单个任务
     * 
     * @param taskId
     * 
     * @returns R.success.code(200).message("接受成功");
     * @returns R.error.code(500).message("接受失败，请联系管理员");
     */
    handleAccept(index, row) {
      let data = { taskId: row.taskId, taskType: row.taskType };
      post('/task/accept', JSON.stringify(data)).then((res) => {
        for (let i = 0, len = this.taskListUnAccept.length; i < len; i++) {
          if (this.taskListUnAccept[i].taskId == row.taskId) {
            let item = this.taskListUnAccept[i];
            this.taskListUnAccept.splice(i, 1);
            this.taskListAccept.push(item);
            this.taskList = this.taskListUnAccept;
          }
        }
      });
    },
    /**
     * @function POST /task/accept/batch
     * @description 接受批量任务
     * 
     * @param taskIdArr[] 任务ID数组
     * 
     * @returns R.success.code(200).message("接受成功");
     * @returns R.success.code(200).message("接受失败，请联系管理员");
     */
    doAccept() {
      let taskIdArr = [];
      for (let i = 0, len = this.selectTask.length; i < len; i++) {
        taskIdArr.push(this.selectTask[i].taskId);
      }
      let data = { taskIdArr: taskIdArr };
      post('/task/accept/batch', JSON.stringify(data)).then((res) => {
        for (let i = 0, len = this.taskListUnAccept.length; i < len; i++) {
          if (taskIdArr.indexOf(this.taskListUnAccept[i].taskId) > -1) {
            let item = this.taskListUnAccept[i];
            this.taskListUnAccept.splice(i, 1);
            // 删除被遍历数组后数组坐标改变，可i--，也可逆向循环往前删除
            i--;
            this.taskListAccept.push(item);
          }
        }
        this.taskList = this.taskListUnAccept;
      });
    },

    /**
     * @function POST /task/search/personal/batch
     * @description 批量查询历史任务
     * 
     * @param userId 用户ID
     * @param season 季度
     * @param year 年度
     * @param taskSource 任务来源（全部/自定义/科室清单/重大决策部署/指标下发/任务池）默认全部
     * 
     * @returns R.success.code(200).message("查询成功").data("taskListAccept, taskListUnAccept")
     * @returns R.success.code(204).message("查询失败")
     */
    taskSearch() {
      let data = {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        season: this.season,
        year: this.year
      };
      post('/task/search/personal/batch', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          res = JSON.parse(res.data.taskList);
          this.taskListAccept = [];
          this.taskListUnAccept = [];
          for (let i = 0, len = res.length; i < len; i++) {
            if (res[i].accept == 1) {
              this.taskListAccept.push(res[i]);
            } else {
              this.taskListUnAccept.push(res[i]);
            }
          }
          if (this.activeTab == "first") {
            this.taskList = this.taskListUnAccept;
          } else {
            this.taskList = this.taskListAccept;
          }
        }
      });
    }
  },
  computed: {
    tableDataTotal() {
      return this.taskAcceptTable.length;
    },
  },
  created() {
    this.taskSources = taskSources;
    this.taskAcceptTable = taskAcceptTable;
    this.taskSearch();
    this.taskList = this.taskListUnAccept;
  },
  watch: {
    activeTab() {
      if (this.activeTab == "first") {
        this.taskList = this.taskListUnAccept;
      } else {
        this.taskSearch();
        this.taskList = this.taskListAccept;
      }
    },
    season() {
      this.taskSearch();
      if (this.activeTab == "first") {
        this.taskList = this.taskListUnAccept;
      } else {
        this.taskList = this.taskListAccept;
      }
    },
    month() {
      this.taskSearch();
      if (this.activeTab == "first") {
        this.taskList = this.taskListUnAccept;
      } else {
        this.taskList = this.taskListAccept;
      }
    },
    taskSource() {
      this.taskSearch();
      if (this.activeTab == "first") {
        this.taskList = this.taskListUnAccept;
      } else {
        this.taskList = this.taskListAccept;
      }
    }
  }
};